export const ADVERTISERS_BTN_RUN_EXPORT = 'ADVERTISERS:HEADER:BUTTON:RUN_EXPORT'
export const ADVERTISERS_RUNNING_EXPORT = 'ADVERTISERS:HEADER:EXPORT_MESSAGE:RUNNING'
export const ADVERTISERS_DOWNLOAD_EXPORT = 'ADVERTISERS:HEADER:EXPORT_MESSAGE:DOWNLOAD'
export const ADVERTISERS_ERROR_TRY_AGAIN = 'ADVERTISERS:HEADER:EXPORT_MESSAGE:ERROR'
export const LOADING = 'SHARED:LOADING'
